import awsExports from '../awsExports';

const DEFAULT_COGNITO_SCOPES = 'openid email profile aws.cognito.signin.user.admin';

const validateSsoEnv = () => {
  const domain = process.env.REACT_APP_COGNITO_DOMAIN;
  const idp = process.env.REACT_APP_COGNITO_IDP;
  const discovery = process.env.REACT_APP_SSO_DISCOVERY_ENDPOINT;

  if (idp && !domain) {
    console.error(
      'SSO misconfiguration: REACT_APP_COGNITO_IDP is set but REACT_APP_COGNITO_DOMAIN is missing. ' +
        'SSO sign-in will fail because there is no OAuth domain to redirect to.',
    );
  }

  if (discovery && !domain) {
    console.error(
      'SSO misconfiguration: REACT_APP_SSO_DISCOVERY_ENDPOINT is set but REACT_APP_COGNITO_DOMAIN is missing. ' +
        'Discovered SSO providers will not work because there is no OAuth domain to redirect to.',
    );
  }

  if (domain && !idp && !discovery) {
    console.warn(
      'SSO configuration: REACT_APP_COGNITO_DOMAIN is set but neither REACT_APP_COGNITO_IDP nor ' +
        'REACT_APP_SSO_DISCOVERY_ENDPOINT is configured. The OAuth domain will have no effect.',
    );
  }
};

validateSsoEnv();

const getRedirectUri = (path, fallback = '') => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return fallback;
  }
  return `${window.location.origin}${path}`;
};

const redirectSignIn =
  process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN ||
  getRedirectUri('/callback');
const redirectSignOut =
  process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT ||
  getRedirectUri('/');

const oauthDomain = String(process.env.REACT_APP_COGNITO_DOMAIN || '').trim();

const oauthConfig = oauthDomain
  ? {
      domain: oauthDomain,
      scope: (process.env.REACT_APP_COGNITO_SCOPES || DEFAULT_COGNITO_SCOPES)
        .split(/\s+/)
        .filter(Boolean),
      redirectSignIn,
      redirectSignOut,
      responseType: process.env.REACT_APP_COGNITO_RESPONSE_TYPE || 'code',
    }
  : awsExports.oauth;

const amplifyConfig = {
  ...awsExports,
  oauth: oauthConfig,
};

export default amplifyConfig;
